export var StaffRole;
(function (StaffRole) {
    StaffRole["ADMIN"] = "ADMIN";
    StaffRole["SUPPORT"] = "SUPPORT";
})(StaffRole || (StaffRole = {}));
export var StaffStatus;
(function (StaffStatus) {
    StaffStatus["ACTIVE"] = "ACTIVE";
    StaffStatus["SUSPENDED"] = "SUSPENDED";
})(StaffStatus || (StaffStatus = {}));
//# sourceMappingURL=staff.types.js.map